<template>
  <v-form
    v-if="isShown"
    class="filter white mb-5"
    @submit.prevent="submit"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="4">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.start_date') }}</label>
            <date-picker
              v-model="localFilter.startDate"
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="4">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.end_date') }}</label>
            <date-picker
              v-model="localFilter.endDate"
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="4">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('views.complaints_report.complaint_number') }}</label>
            <v-text-field
              v-model="localFilter.complaintNumber"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.status') }}</label>
            <v-select
              v-model="localFilter.status"
              :items="complaintStatuses"
              clearable
              solo
              hide-details
            />
          </div>
        </v-col>
        <v-col cols="3">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('common.order_sum_with_vat') }}</label>
            <v-text-field
              v-model.number="localFilter.totalWithVAT"
              type="number"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col cols="4">
          <div class="input-block input-block_white">
            <label class="input-block__label">{{ $t('views.complaints_report.sender') }}</label>
            <v-text-field
              v-model="localFilter.sender"
              hide-details
              solo
            />
          </div>
        </v-col>
        <v-col
          cols="2"
          class="filter__apply"
        >
          <v-btn
            type="submit"
            color="primary"
            outlined
            large
            class="filter__apply-button"
          >
            {{ $t('common.apply') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { complaintStatuses } from '@/utils/enums';
import DatePicker from '@/components/common/DatePicker';

export default {
  name: 'ComplaintsReportFilter',

  components: {
    DatePicker,
  },

  model: {
    prop: 'isShown',
  },

  props: {
    isShown: {
      type: Boolean,
      default: false,
    },

    filter: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localFilter: {
        startDate: '',
        endDate: '',
        complaintNumber: '',
        status: '',
        totalWithVAT: null,
        sender: '',
      },
    };
  },

  computed: {
    complaintStatuses() {
      return complaintStatuses.map((status) => ({
        value: status,
        text: this.$t(`enums.complaint_statuses.${status.toLowerCase()}`),
      }));
    },
  },

  watch: {
    isShown(value) {
      if (value) {
        this.init();
      }
    },
  },

  methods: {
    init() {
      this.localFilter = { ...this.filter };
    },

    submit() {
      this.$emit('applyFilter', this.localFilter);
    },
  },
};
</script>
